var ezdia;
(function (ezdia) {
    var HtmlTemplates = ezdia.templates.reportingDashboard;
    var ReporitngDashbaord = /** @class */ (function () {
        function ReporitngDashbaord() {
            var _this = this;
            this.createEmptyPage = function () {
                var template = HtmlTemplates.emptyChart;
                var chartTemplateName = $.ezdia.config.chartTemplateName;
                $("#ez-dashboard-" + chartTemplateName).html(template());
            };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this.createChartElements = function (obj, key, name) {
                var chartTemplateName = $.ezdia.config.chartTemplateName;
                var wrapper = $('<div>', {
                    id: key,
                    class: 'reporting-chart-wrapper'
                });
                $("#ez-dashboard-" + chartTemplateName).append(wrapper);
            };
            this.renderChartAfterFilterChange = function (filterElement) {
                var name = $(filterElement).data('name');
                var charts = $.data(document, 'ez.reportingDashboard');
                charts = charts[name];
                var chartsCopy = __assign({}, charts);
                var url = charts.url;
                if (filterElement.checked) {
                    url = url + "&isComparable=true";
                }
                $("#" + charts.id)
                    .find('.ez-chart-overlay,.ez-chart-overlay-content')
                    .remove();
                chartsCopy.url = url;
                var tabName = $(filterElement).data('tabname');
                if (!tabName) {
                    charts.panels.forEach(function forEach(element) {
                        $("#" + chartsCopy.id)
                            .find("#" + element.id)
                            .html('<div class="ez-loading"><span class="text"><i class="fa fa-spinner fa-spin"></i><br>Loading...</span></div>');
                    });
                    chartsCopy = [chartsCopy];
                }
                else {
                    charts.panels.forEach(function forEach(element) {
                        if (tabName === element.tabName) {
                            $("#" + chartsCopy.id)
                                .find("#" + element.id)
                                .html('<div class="ez-loading"><span class="text"><i class="fa fa-spinner fa-spin"></i><br>Loading...</span></div>');
                        }
                    });
                }
                _this.renderCharts(chartsCopy, tabName);
            };
            this.options = {
                charts: [],
                pinObj: {},
                pinWrapperId: '',
                keys: [],
                widgets: {
                    date: {},
                    group: [],
                    select: [],
                    tag: []
                }
            };
        }
        ReporitngDashbaord.prototype.events = function () {
            $('.ez-chart-tabs').on('click', 'a', $.proxy(this.renderOnClick, this));
            var self = this;
            $('.ez-chart-checkbox').on('click', function click() {
                self.renderChartAfterFilterChange(this);
            });
            $('.ez-clear-all').on('click', function click() {
                var formname = $(this).data('name');
                var formInputs = $(this)
                    .parent()
                    .find('input[type="text"]:visible.form-control');
                $.each(formInputs, function (i, formInput) {
                    var $formInput = $(formInput);
                    var inputData = $formInput.data();
                    var type = inputData.type;
                    var id = formInput.id;
                    if (type !== 'text') {
                        $formInput.typeahead('val', '');
                        $("#" + id + "-date-value").val('');
                    }
                    $formInput.val('');
                });
                $(this).removeClass('ez-display-inline');
                $("#ez-dashboard-charts-" + formname + "-compare").removeAttr('checked');
                self.renderChartAfterFilterChange(this);
            });
        };
        ReporitngDashbaord.prototype.createChartsWrapper = function () {
            var config = $.ezdia.config.pageParams;
            var chartTemplateName = $.ezdia.config.chartTemplateName;
            var queries = config.queries || [];
            var charts = $.data(document, 'ez.reportingDashboard');
            var template = $.ezdia.template.get("dashboard-" + chartTemplateName, {
                'partial-dashboard-search': 'reporting-chart-search',
                'partial-filter-options': 'reporting-filter-options'
            });
            var suffix = 'ez-dashboard-charts-';
            var firstKey = null;
            var tab = config.tab;
            var wrapper = null;
            var coltwo = {};
            var arr = [];
            // eslint-disable-next-line consistent-return
            $.each(this.options.charts, function (i, obj) {
                if (obj.name === 'client_rocs') {
                    ezdia.charts.rocs.originalChart = obj;
                    return true;
                }
                arr.push(obj);
            });
            this.options.charts = $.merge([], arr);
            var self = this;
            $.each(this.options.charts, function each(i, obj) {
                var e_1, _a;
                // initialising template object again to the original value
                template = $.ezdia.template.get('dashboard-generic-charts-wrapper', {
                    'partial-dashboard-search': 'reporting-chart-search',
                    'partial-filter-options': 'reporting-filter-options'
                });
                var name = null;
                var key = null;
                var chartId = null;
                if (tab === 'Dashboard') {
                    name = ezdia.util.sanitizer.specialChar(obj.pagename || obj.name);
                    name = name.toLowerCase();
                    key = suffix + name;
                    if (!firstKey) {
                        firstKey = {
                            link: name,
                            div: key
                        };
                    }
                    self.createChartElements(obj, key, name);
                    wrapper = $("#" + key);
                    if (obj.type === 'generic') {
                        chartId = obj.name;
                    }
                    else {
                        chartId = obj.name + config.account + config.role;
                    }
                    if (queries.length) {
                        // obj.pin = checkPin.call(self, chartId) ? 'unpin' : 'pin';
                    }
                    else {
                        obj.pin = 'pin';
                    }
                    obj.share = config.share;
                }
                else {
                    chartId = obj.name + obj.account + obj.role;
                    wrapper = $("#ez-dashboard-" + chartTemplateName);
                    name = tab;
                    if (!obj.global) {
                        obj.pin = 'unpin';
                    }
                    else {
                        obj.share = config.share;
                        obj.export =
                            obj.type === 'task' || obj.type === 'html'
                                ? false
                                : config.export;
                        if (!obj.export && !config.share) {
                            obj.hideactions = true;
                        }
                    }
                }
                this.config = this.config || {};
                obj.layout = this.config.layout
                    ? "col-layout-" + this.config.layout
                    : '';
                obj.id = suffix + ezdia.util.sanitizer.specialChar(chartId);
                obj.tab = tab;
                obj.export =
                    obj.type === 'task' || obj.type === 'html' ? false : config.export;
                if ((obj.type === 'chart' ||
                    obj.type === 'task' ||
                    obj.type === 'html') &&
                    coltwo[name]) {
                    wrapper = $(coltwo[name]).closest('[data-row="wrapper"]');
                    coltwo[name] = false;
                    obj.norow = true;
                }
                else if ((obj.type === 'chart' ||
                    obj.type === 'task' ||
                    obj.type === 'html') &&
                    !coltwo[name]) {
                    coltwo[name] = "#" + obj.id;
                }
                wrapper.append(template(obj));
                if (obj.type === 'generic') {
                    wrapper = $("#" + obj.id);
                    if (obj.panels && !obj.tabView) {
                        var isVisualEmpty_1 = true;
                        $.each(obj.panels, function eachpanel(_i, chartObject) {
                            if (chartObject.type === 'chartsummary') {
                                template = $.ezdia.template.get('reporting-charts-summary-wrapper', {});
                                $("#" + obj.id + " .ez-charts-summaryPanel").append(template(chartObject));
                            }
                            else {
                                template = $.ezdia.template.get('reporting-charts-wrapper', {});
                                if (isVisualEmpty_1) {
                                    $("#" + obj.id + " .ez-charts-visualPanel").append(template(chartObject));
                                    isVisualEmpty_1 = false;
                                }
                                else {
                                    var $wrapper = $('<div>', {
                                        class: 'ez-charts-visualPanel visual-copy'
                                    });
                                    $("#" + obj.id + " .ez-dashboard-charts").append($wrapper);
                                    $("#" + obj.id + " .visual-copy").append(template(chartObject));
                                }
                            }
                        });
                        $("#" + obj.id + " .panel-body").addClass("charts-panel-wrapper col-layout-" + obj.panels.length);
                    }
                    else if (obj.panels && obj.tabView) {
                        var tabArray_1 = [];
                        $.each(obj.panels, function eachpanel(_i, chartObject) {
                            var tabObject = { name: '', label: '' };
                            tabObject.name = chartObject.tabName;
                            tabObject.label = chartObject.tabLabel;
                            chartObject.parentName = obj.name;
                            if (chartObject.type === 'chartsummary') {
                                template = $.ezdia.template.get('reporting-charts-summary-wrapper', {});
                                $("#ez-tab-" + chartObject.tabName)
                                    .find('.ez-charts-summaryPanel')
                                    .append(template(chartObject));
                                $("#ez-tab-" + chartObject.tabName)
                                    .find('.ez-charts-summaryTable')
                                    .show();
                            }
                            else {
                                template = $.ezdia.template.get('reporting-charts-tabs-wrapper', {});
                                $("#" + obj.id + " .ez-tab-content").append(template(chartObject));
                                tabArray_1.push(tabObject);
                            }
                        });
                        $("#ez-charts-nav-bar-" + obj.name + " .ez-chart-tabs").html($.ezdia.groupFormField.chartTabs(tabArray_1));
                        var tabElement = $("#" + obj.id)
                            .find('.ez-nav-pills .active')
                            .attr('data-tab');
                        $("#" + obj.id).find("#" + tabElement).addClass('active');
                    }
                    charts[name] = obj;
                }
                else {
                    charts[name].push(obj);
                }
                if (obj.filter) {
                    try {
                        for (var _b = __values(obj.filter), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var filter = _c.value;
                            var type = filter.type;
                            filter.edittype = type;
                            filter.editable = true;
                            $("[name=" + filter.name + "]").on('change', function (e) {
                                self.search(e);
                            });
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    $.ezdia.widgets.renderAll(obj.filter);
                }
            });
            this.events.call(this);
            return charts;
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ReporitngDashbaord.prototype.render = function (param) {
            var config = $.ezdia.config.pageParams;
            var queries = ezdia.util.jsonParse(config.queries) || {};
            var charts = null;
            $.ezdia.config.pageParams.queries = queries;
            $.data(document, 'ez.reportingDashboard', {});
            if ($.isEmptyObject(this.options.charts)) {
                this.createEmptyPage();
            }
            else {
                charts = this.createChartsWrapper.call(this);
                this.renderCharts(charts);
                $('.ez-scroll-nav-pills').scrollingNav({
                    clickable: true
                });
            }
            if (ezdia.charts.rocs.originalChart) {
                ezdia.charts.rocs.render();
            }
            pageLoadingDone();
        };
        ReporitngDashbaord.prototype.renderOnClick = function (e) {
            e.preventDefault();
            var elem = $(e.currentTarget);
            var parent = elem.parent();
            var queryName = elem.parents('.ez-scroll-nav-pills-form').data('name');
            var tabName = elem.data('name');
            var render = parent.attr('data-render');
            var parentContainer = elem.parents('.reporting-chart-wrapper');
            var charts;
            parent.addClass('active').siblings().removeClass('active');
            var element = parentContainer.find("#ez-tab-" + tabName);
            if (element.data('noData')) {
                elem
                    .parents('.reporting-chart-wrapper')
                    .find('.ez-chart-overlay,.ez-chart-overlay-content')
                    .show();
            }
            else {
                elem
                    .parents('.reporting-chart-wrapper')
                    .find('.ez-chart-overlay,.ez-chart-overlay-content')
                    .hide();
            }
            parentContainer
                .find("#ez-dashboard-charts-" + queryName + " .ez-tab-content-wrapper")
                .removeClass('active');
            element.addClass('active');
            if (!render) {
                charts = $.data(document, 'ez.reportingDashboard');
                charts = charts[queryName];
                this.renderCharts(charts, tabName);
                parent.attr('data-render', 'true');
            }
        };
        ReporitngDashbaord.prototype.drawChart = function (obj, response, parentID) {
            var self = this;
            switch (obj.type) {
                case 'html':
                case 'url':
                    self.htmlCard(response, obj);
                    break;
                default:
                    $.ezdia.chart.create(response, obj, parentID);
                    break;
            }
        };
        ReporitngDashbaord.prototype.ajaxCall = function (url, obj, tabName) {
            var self = this;
            if (obj.type === 'geochart') {
                $.ajax({
                    url: url,
                    dataType: 'json',
                    success: function (resp) {
                        var response = resp.dashboard[0];
                        $.ezdia.chart.create(response, obj);
                    }
                });
            }
            else {
                $.ajax({
                    url: url,
                    dataType: 'json',
                    success: function (resp) {
                        var e_2, _a;
                        var response = resp.dashboard[0];
                        var template = $.ezdia.template.get('reporting-chart-group', {});
                        try {
                            for (var _b = __values(response.filterFields), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var filter = _c.value;
                                if (filter.config) {
                                    filter.config = ezdia.util.jsonParse(filter.config);
                                }
                                if (filter.type === 'group' && filter.config) {
                                    filter.edittype = filter.type;
                                    filter.editable = true;
                                    filter.parentName = response.name;
                                    $("#" + filter.name + "-filter-container")
                                        .empty()
                                        .append(template(filter));
                                    $("[name=" + filter.name + "]").change(function (e) {
                                        self.search(e);
                                    });
                                    $.ezdia.widgets.renderAll([filter]);
                                    $("#" + filter.name).typeahead('val', filter.value);
                                    $("#" + filter.name + "-date-value").val(filter.value);
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        if (response.helperText) {
                            $("#ez-dashboard-charts-" + response.name)
                                .find('.optional-descriptive')
                                .html(response.helperText);
                        }
                        if (obj.panels && !obj.tabView) {
                            $.each(obj.panels, function each(i, chartObject) {
                                chartObject.started = false;
                                chartObject.sample = false;
                                self.drawChart(chartObject, response.panels[chartObject.name], obj.id);
                            });
                        }
                        else if (tabName) {
                            $.each(obj.panels, function each(i, chartObject) {
                                if (tabName === chartObject.name ||
                                    tabName === chartObject.tabName) {
                                    var tab = $("#" + obj.id).find("#ez-tab-" + tabName);
                                    tab.addClass('active');
                                    $("#" + obj.id)
                                        .find("#ez-nav-" + tabName)
                                        .attr('data-render', 'true');
                                    chartObject.started = false;
                                    chartObject.sample = false;
                                    self.drawChart(chartObject, response.panels[chartObject.name], obj.id);
                                }
                            });
                        }
                        else {
                            response = response.panels;
                            self.drawChart(obj.panels[0], response[Object.keys(response)[0]], obj.id);
                        }
                    },
                    error: function (response) {
                        switch (obj.type) {
                            case 'url':
                                self.htmlCard(response, obj);
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
        };
        ReporitngDashbaord.prototype.search = function (e) {
            var elem = $(e.currentTarget);
            var frm = elem.closest(".inline-chart-action");
            var name = elem.context.dataset.name;
            elem
                .parents('.reporting-chart-wrapper')
                .find('.ez-chart-overlay,.ez-chart-overlay-content')
                .remove();
            var obj = $.data(document, 'ez.reportingDashboard');
            var url = null;
            // eslint-disable-next-line consistent-return
            $.each(obj, function (i, chart) {
                if (chart.name === name) {
                    chart.started = false;
                    obj = chart;
                    return false;
                }
            });
            obj.panels.forEach(function (element) {
                $("#" + obj.id)
                    .find("#" + element.id)
                    .html('<div class="ez-loading"><span class="text"><i class="fa fa-spinner fa-spin"></i><br>Loading...</span></div>');
            });
            $("#" + obj.id)
                .find('.legend-count')
                .html('<i class="fa fa-spinner fa-spin"></i>');
            var isComparable = elem
                .parents('.dashboard-panel')
                .find('.ez-chart-checkbox');
            isComparable.removeAttr('disabled');
            $("#" + obj.id).find('.ez-nav-pills li').attr('data-render', '');
            if (elem.val() && elem[0].id.indexOf('account_name') === -1) {
                elem
                    .parents('.inline-chart-action')
                    .find('.ez-clear-all')
                    .addClass('ez-display-inline');
            }
            else {
                elem
                    .parents('.inline-chart-action')
                    .find('.ez-clear-all')
                    .removeClass('ez-display-inline');
                $("#" + obj.id).find('.ez-tab-content-wrapper').data('noData', false);
                var formInputs = $(elem)
                    .parents('.inline-chart-action')
                    .find('input[type="text"]:visible.form-control');
                $.each(formInputs, function eachformInputs(i, formInput) {
                    var $formInput = $(formInput);
                    var inputData = $formInput.data();
                    var type = inputData.type;
                    var id = formInput.id;
                    if (type !== 'text') {
                        $formInput.typeahead('val', '');
                        $("#" + id + "-date-value").val('');
                    }
                    $formInput.val('');
                });
            }
            url = obj.url + "&" + frm.find('select, textarea, input').serialize();
            elem
                .parents('.dashboard-panel')
                .find('.ez-charts-summaryTable')
                .css('pointer-events', 'all');
            if (elem.attr('name').indexOf('account_name') > -1) {
                isComparable.removeAttr('checked');
                elem.parents('.dashboard-panel').find('.noPublishingHistory').hide();
            }
            else if ($(isComparable).prop('checked')) {
                url = url + "&isComparable=true";
            }
            var tabName;
            if (obj.tabView) {
                tabName = $("#" + obj.id + " li.active").text().toLowerCase();
                url += "&tabName=" + tabName;
            }
            this.ajaxCall(url, obj, tabName);
        };
        ReporitngDashbaord.prototype.renderCharts = function (charts, tabNameVal) {
            if (!charts) {
                return;
            }
            var self = this;
            var tabName = tabNameVal;
            var url;
            if (charts.tabView) {
                var frm = $("#" + charts.id).find('.inline-chart-action');
                url = charts.url;
                url = url + "&" + frm.find('select, textarea, input').serialize();
                tabName = tabName || charts.name;
                url += "&tabName=" + tabName;
                self.ajaxCall(url, charts, tabName);
            }
            else {
                $.each(charts, function (i, obj) {
                    var frm = $("#" + obj.id).find('.inline-chart-action');
                    url = obj.url + "&" + frm.find('select, textarea, input').serialize();
                    tabName = obj.panels[0].name;
                    if (obj.tabView) {
                        url += "&tabName=" + tabName;
                    }
                    self.ajaxCall(url, obj, tabName);
                });
            }
        };
        return ReporitngDashbaord;
    }());
    var pages;
    (function (pages) {
        pages.reportingDashboard = new ReporitngDashbaord();
    })(pages = ezdia.pages || (ezdia.pages = {}));
})(ezdia || (ezdia = {}));
